export let validateDOB = (inputdate) => {

    const date = new Date(inputdate)
    let result;


    var today = new Date().toISOString().replace('-', '/').split('T')[0].replace('-', '/');
    const newDate = new Date(today)
    // const diffTime = Math.abs(newDate.getFullYear() - date.getFullYear())

    var diffTime = newDate.getFullYear() - date.getFullYear();
        var m = newDate.getMonth() - date.getMonth();
        if (m < 0 || (m === 0 && newDate.getDate() < date.getDate())) {
            diffTime--;
        }

    if (diffTime >= 60) {
        result = { age: diffTime, majority: "Senior" }

    }

    if (diffTime >= 18 && diffTime < 60) {
        result = { age: diffTime, majority:"Major"}
    }

    if (diffTime < 18) {
        result = { age: diffTime, majority:"Minor"}

    }

    return result;

}


/**
 * Validates a date string in the format "DD-MM-YYYY".
 * This is to validate DOB for csv/excel file.
 
 * This function checks if the provided date is valid, ensuring it:
 * 1. Matches the correct format.
 * 2. Represents a real date (e.g., not February 30).
 * 3. Is not a future date.
 * 4. Correctly accounts for leap years.

 * @param {string} dateStr - The date string to validate in "DD-MM-YYYY" format.
 * @returns {Object} An object containing:
 *   - isValid: {boolean} Indicates if the date is valid.
 *   - errorMessage: {string} A message detailing the validation result.
 */
export const validateDate = (dateStr) => {
    try {
      const [day, month, year] = dateStr.split("-");
      const dateObj = new Date(year, month - 1, day);
      const today = new Date();
      if (
        dateObj.getDate() !== Number(day) ||
        dateObj.getMonth() + 1 !== Number(month) ||
        dateObj.getFullYear() !== Number(year)
      ) {
        return { isValid: false, errorMessage: "Invalid date or check for the days in month" };
      }
  
      if (dateObj > today) {
        return { isValid: false, errorMessage: "Date cannot be in the future." };
      }
      // leap year check
      const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
      if (month === 2 && day === 29 && !isLeapYear) {
        return { isValid: false, errorMessage: "February cannot have 29 days in a non-leap year." }; 
      }
      return { isValid: true, errorMessage: "Date is valid." };
    } catch (error) {
      return {
        isValid: false,
        errorMessage: 'Invalid date format. Please use "DD-MM-YYYY".',
      };
    }
};
  
  
